import { AbilityBuilder } from '@casl/ability';

/**
 * @param role contains details about the permissions of the logged in user: privileges, resources, actions
 */
export function defineAbilitiesFor(role) {
    const { can, rules } = new AbilityBuilder();

    for (let rolePrivilege of role.rolePrivileges) {
        can(rolePrivilege.privilege.action.name, rolePrivilege.privilege.resource.name);
    }

    return rules;
}
